export interface TrendOptions {
  base: number
  points?: number
  volatility?: number
  min?: number
  integer?: boolean
  precision?: number
}

export interface TrendSeries {
  points: number[]
  delta: number
  direction: 'up' | 'down' | 'flat'
}

const roundValue = (value: number, integer: boolean, precision: number) => {
  if (integer) return Math.round(value)
  const factor = 10 ** precision
  return Math.round(value * factor) / factor
}

export const generateTrendSeries = ({
  base,
  points = 14,
  volatility = 0.08,
  min = 0,
  integer = false,
  precision = 2
}: TrendOptions): TrendSeries => {
  const series: number[] = []
  let current = base || 0

  for (let i = 0; i < points; i += 1) {
    const swing = (Math.random() - 0.5) * 2
    const change = swing * volatility * (base || 1)
    current = Math.max(min, current + change)
    series.push(roundValue(current, integer, precision))
  }

  const first = series[0] ?? 0
  const last = series[series.length - 1] ?? 0
  const delta = first === 0 ? 0 : (last - first) / first
  const direction = delta > 0.01 ? 'up' : delta < -0.01 ? 'down' : 'flat'

  return {
    points: series,
    delta: Number(delta.toFixed(4)),
    direction
  }
}
